<template>
    <div v-if="isShow" class="l-currency-body">
        <div class="l-currency-main">
            <CurrencyTop :userType="userType"></CurrencyTop>
            <CurrencyRank :rank="currencyData.userRank" :userType="userType" :coin="currencyData.coin"
                :winnerCoin="currencyData.winnerCoin">
            </CurrencyRank>
            <CurrencyContent :userType="userType"></CurrencyContent>
            <CurrencyTitle :rank="currencyData.userRank" :userType="userType" :coin="currencyData.coin"
                :winnerCoin="currencyData.winnerCoin"></CurrencyTitle>
            <CurrencyButton :userType="userType" :taskId="currencyData.taskId" @closeRule="handleClose">
            </CurrencyButton>
            <!-- <img class="top-img" src="./images/top.png" alt=""> -->
            <!-- <div class="rank">第<span>{{ dataRank }}</span>名</div> -->
            <!-- <img class="top-content" src="./images/content.png" alt=""> -->
            <!-- <div class="title">
                <div class="title-backgruond"></div>
                <div class="title-body">
                    <div>恭喜你！在本次直播指导中获得<span>第{{ dataRank }}名</span>。快来领取奖励吧！</div>
                    <div>
                        <img src="./images/l-coin.png" alt="">
                        <span>x{{ currencyData.coin }}</span>
                    </div>
                </div>

            </div> -->
            <!-- <div class="button" @click="handleLivePrize()">
                领取奖励
            </div> -->
        </div>
    </div>
</template>
<script>
import { liveType } from "./../../../constans/enum"
import CurrencyTop from "./components/currency-top"
import CurrencyRank from "./components/currency-rank"
import CurrencyContent from "./components/currency-content"
import CurrencyTitle from "./components/currency-title"
import CurrencyButton from "./components/currency-button"
export default {
    components: {
        CurrencyTop,
        CurrencyRank,
        CurrencyContent,
        CurrencyTitle,
        CurrencyButton
    },
    props: {
        opsions: {
            type: Object,
            default: () => {
                return {}
            }
        },
        taskId: {
            default: null,

        },


    },
    watch: {
        opsions: {
            handler: function (val) {
                this.currencyData = val
                this.userType = 1
                // this.currencyData.receiveReward = 0
                if (this.currencyData.showRead) {
                    if (this.currencyData.receiveReward === 0) {
                        if (this.currencyData.coin || this.currencyData.winnerCoin) {
                            this.isShow = true
                        } else {
                            this.isShow = false
                        }
                    } else {
                        this.isShow = false
                    }
                } else {
                    if (this.currencyData.receiveReward === 0) {
                        if (this.currencyData.live !== liveType.USER_APPEAR) {
                            this.isShow = true
                            this.userType = 3
                        } else {
                            if (parseFloat(this.currencyData.singeRate) < 50) {
                                this.isShow = true
                                this.currencyData.winnerCoin ? this.userType = 1 : this.userType = 2;
                            } else {
                                if (this.currencyData.coin || this.currencyData.winnerCoin) {
                                    this.isShow = true
                                } else {
                                    this.isShow = false
                                }
                            }
                        }

                    } else {
                        this.isShow = false
                    }
                }


            },
            deep: true
        },
    },
    mounted() {
    },
    data() {
        return {
            isShow: false,
            currencyData: {

            },
            userType: 1// 1可领取弹窗，2未达到50%且没有进步奖弹窗，3缺席

        }
    },
    methods: {
        handleClose() {
            this.isShow = false
        }
    }


}
</script>
<style scoped lang="stylus">
@import "./index.styl"
</style>